import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Message, translator } from 'mage-i18n';
import { IllustrationThumbsUp, Typography, SpacerVertical } from '@klarna/bubble-ui';

import { ContainerTemplate, LinkWithoutHref, MessagingStep } from '@/components';
import { getSetupData } from '@/selectors/data';

const tPrefix = 'products-fe.containers.contact_received';

const styles = {
  message: {
    fontSize: 19,
  },
};

const ContactReceivedInner = ({ email, t, onNext, merchantId }) => {
  return (
    <ContainerTemplate>
      <MessagingStep illustration={<IllustrationThumbsUp />} title={[t(`${tPrefix}.title`)]}>
        <SpacerVertical small />
        <Typography textToken="text-style/text/super-paragraphs/tall/regular">
          <Message path={`${tPrefix}.message_1`} />
          <br />
          <Message path={`${tPrefix}.message_2`} />
          <LinkWithoutHref isUnderlined target="_blank">
            <span style={styles.message}>{email}</span>
          </LinkWithoutHref>
        </Typography>
      </MessagingStep>
    </ContainerTemplate>
  );
};

ContactReceivedInner.propTypes = {
  email: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  merchantId: PropTypes.string,
};

export const ContactReceived = compose(
  connect(state => ({
    t: translator(state),
    email: getSetupData(state).email,
  })),
)(ContactReceivedInner);
